export const Paragraph = ({ fill = '#001965' }: { fill?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M4.58398 8.33341H7.08398"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.83464 3.33337V8.33337"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.33398 4.46504V3.61087C8.33398 3.45754 8.20982 3.33337 8.05648 3.33337H3.61148C3.45815 3.33337 3.33398 3.45754 3.33398 3.61087V4.46504"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.33398 11.6667V15C3.33398 15.9209 4.07982 16.6667 5.00065 16.6667H15.834C16.7548 16.6667 17.5007 15.9209 17.5007 15V5.00004C17.5007 4.07921 16.7548 3.33337 15.834 3.33337H11.6673"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.66797 13.3334H14.168"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M10 10H14.1667" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M10.834 6.66667H14.1673"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
